module.exports = __webpack_public_path__ + "img/register.a96bace8.png";